import React from "react";
import numeral from "../../../../node_modules/numeraljs/numeral.js";
import { XRayTooltipHeader } from "./../XrayUtils.js";

export const XRayTooltipNewReturning = (props) => {
  const { data, close } = props;

  return (
    <div>
      <XRayTooltipHeader date={data.activeLabel} close={close} />

      <main className="standard-tooltip__main">
        {Object.keys(data.activePayload)
          .sort(
            (a, b) => data.activePayload[b].value - data.activePayload[a].value
          )
          .filter((key) => data.activePayload[key].value > 0)
          .map((key, index) => {
            return (
              <div className="standard-tooltip__item" key={key}>
                <span
                  className="standard-tooltip__icon"
                  // set the backgroun color according the chart name
                  style={{
                    background: data.activePayload[key].color,
                  }}
                />
                <span>New</span>
                <span className="standard-tooltip__value">
                  {numeral(data.activePayload[key].value).format("0.0%")}
                </span>
              </div>
            );
          })}
      </main>
    </div>
  );
};
